import api from '../api/axios'

var interceptorID = undefined;

// Set all future requests to use the token.
const setToken = () => {
    interceptorID = api.interceptors.request.use(
        async config => {
            const token = localStorage.getItem('token');
            config.headers = {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
                'x-client-version': process.env.REACT_APP_VERSION ? process.env.REACT_APP_VERSION : '1.0.0',
                useCredentials: true
            }
            return config;
        },
        error => {
            Promise.reject(error)
        });
}

// Get new Token by API CALL.
export const tokenAPICALL = async (user,pass)=> {
    const {data} = await api.post(`/token`, {
        "username": user,
        "password": pass,
    }, {
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        }
    })

    const now = new Date().getTime();
    const expiryDate = now + data.document.expires_in;

    localStorage.setItem('token', data.document.access_token);
    localStorage.setItem('token_exp', expiryDate);
    localStorage.setItem('tmn_nm', data.document.nama);
    setToken();
    return({
        token: data.document.access_token,
        role: data.document.role,
        fullName: data.document.nama
    });
}

// Check the Token stored in Cookies.
const getToken = async (setJwt,user,pass)=> {
    const storedJwt = localStorage.getItem('token');
    const expiration = localStorage.getItem( 'token_exp')
    if(expiration&&storedJwt) {
        const now = new Date().getTime();
        if (now < expiration) {
            console.log("Keep Token");
            setJwt(await tokenAPICALL(user,pass).token);
        }
        else{
            // Token Expired, Get new token
            console.log("Expired Token");
            setJwt(await tokenAPICALL(user,pass).token);
        }
    }
    else{
        // No token recorder in session, Get new token
        console.log("No Token")
        setJwt( await tokenAPICALL(user,pass).token);
    }
};

export const getCachedToken = () => {
    const storedJwt = localStorage.getItem('token');
    const expiration = localStorage.getItem('token_exp');
    if(expiration && storedJwt) {
        const now = new Date().getTime();
        if (now < expiration) {
            setToken();
            return storedJwt;
        }
    }
    return null;
};

export const getCachedFullName = () => {
    return localStorage.getItem('tmn_nm');
}

export const removeToken = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('token_exp');
    localStorage.removeItem('tmn_nm');
    if (interceptorID) {
        api.interceptors.request.eject(interceptorID);
    }
};

export default getToken;
